// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState } from 'react';
import { Element } from 'react-scroll';
import { FormattedMessage } from 'react-intl';
import { S } from '../ExamPageStyle';
import Collapse from '../../../components/Collapse';

const Overview = (props: any): JSX.Element => {

  const [isShow, setShow] = useState(true);

  useEffect(() => {
    if (!isShow) {
      setShow(true);
    }
  }, [isShow])

  const handleRenderTitle = () => {
    return (
      <Element name={'m-0'}>
        <S.OverviewTitle><FormattedMessage id="E027" /></S.OverviewTitle>
      </Element>
    )
  }

  return (
    <Collapse isShow={isShow} title={handleRenderTitle}>
      <S.OverviewText>{props.children}</S.OverviewText>
    </Collapse>
  )
}

export default Overview;
